import _ from 'lodash';
import Moment from 'moment';

const MANUAL_DP_FIELDS = [
  'fundSize',
  'fundSizeDate',
  'pdsFileUrl',
  'managementFee',
  'performanceFee',
  'totalCostRatio',
  'financialYearEndFeesDate',
  'buySpread',
  'sellSpread',
  'latestProspectusDate',
  'dayEndEntryPrice',
  'dayEndExitPrice',
  'dayEndNavPrice',
  'dayEndPricingUpdateDate',
];

const MANUAL_MS_PERFORMANCE_FIELDS = [
  '1MonthReturnPercent',
  '3MonthReturnPercent',
  '6MonthReturnPercent',
  '1YearReturnPercent',
  '2YearReturnPercent',
  '3YearReturnPercent',
  '5YearReturnPercent',
  '10YearReturnPercent',
  'returnSinceInceptionPercent',
];

const asPayload = (field, value, dpValue) => {
  const valueToShow = value instanceof Moment ? value.format('DD/MM/YYYY') : value;

  return { field, value: valueToShow, dpValue };
};

const toDpOverrides = fund => {
  const overrides = [];
  MANUAL_DP_FIELDS.forEach(field => {
    const value = fund[field];
    if (value) {
      const dpField = `dp${_.upperFirst(field)}`;
      overrides.push(asPayload(field, value, fund[dpField]));
    }
  });
  return overrides;
};

const toPerformanceAttribute = (f, field, key) => _.find(_.get(f, key), p => p.name === field);

const toMsPerformanceOverrides = fund => {
  const overrides = [];
  MANUAL_MS_PERFORMANCE_FIELDS.forEach(field => {
    const attribute = toPerformanceAttribute(fund, field, 'performance');
    const value = _.get(attribute, 'value');
    if (value) {
      const dpField = `dp${_.upperFirst(field)}`;
      const dpAttribute = toPerformanceAttribute(fund, dpField, 'dpPerformance');
      overrides.push(asPayload(field, value, _.get(dpAttribute, 'value')));
    }
  });
  return overrides;
};

const getManualOverrides = fund => {
  const first = toDpOverrides(fund);
  const second = toMsPerformanceOverrides(fund);
  first.push(...second);
  return first;
};

export default getManualOverrides;
